export default __webpack_public_path__ + "media/images/landing-38-550x420-6a6075777443e1b756ee8752c55ee041.jpg";